import React from 'react';

import "./MoreAboutIt.css";

const MoreAboutIt = () => {
  return(
    <button className="more-button">
      <p className="more-button-text">MORE ABOUT IT</p>
    </button>
  )
}

export default MoreAboutIt;